import React from 'react';
import { MessageSquare, Clock } from 'lucide-react';

// Compact "At a Glance" panel: the chat count and last-active time as small
// stat rows (replaces the two oversized stat cards on the old overview).
const AtAGlance = ({ chatCount = 0, lastActive = null, loading = false }) => {
  const lastActiveLabel = () => {
    if (!lastActive) return 'No activity yet';
    const d = new Date(lastActive);
    const days = Math.floor((Date.now() - d.getTime()) / 86_400_000);
    if (days === 0) return 'Active today';
    if (days === 1) return 'Active yesterday';
    if (days < 7) return `Active ${days} days ago`;
    return `Active ${d.toLocaleDateString()}`;
  };

  return (
    <section className="rounded-2xl border border-gray-200/80 dark:border-gray-800 bg-white dark:bg-gray-900/40">
      <header className="px-5 py-3.5 border-b border-gray-100 dark:border-gray-800">
        <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-400 dark:text-gray-500">
          At a Glance
        </span>
      </header>
      <div className="grid grid-cols-2 divide-x divide-gray-100 dark:divide-gray-800">
        <Row
          icon={<MessageSquare size={15} className="text-blue-600 dark:text-blue-400" />}
          label="Conversations"
          value={loading ? '…' : chatCount}
          hint="Total to date"
        />
        <Row
          icon={<Clock size={15} className="text-blue-600 dark:text-blue-400" />}
          label="Last active"
          value={loading ? '…' : lastActiveLabel()}
          valueClass="text-[14px]"
        />
      </div>
    </section>
  );
};

const Row = ({ icon, label, value, hint, valueClass = 'text-[20px]' }) => (
  <div className="flex items-center gap-3 px-5 py-4">
    <span className="shrink-0 h-9 w-9 rounded-xl bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center">
      {icon}
    </span>
    <div className="min-w-0">
      <p className="text-[11px] uppercase tracking-wide text-gray-400 dark:text-gray-500">{label}</p>
      <p className={`font-rasa font-semibold text-gray-900 dark:text-white leading-tight ${valueClass}`}>
        {value}
      </p>
      {hint && <p className="text-[11px] text-gray-400 dark:text-gray-500 mt-0.5">{hint}</p>}
    </div>
  </div>
);

export default AtAGlance;
